"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'cashpledge',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      form: {},
      stat_data: {},
      tableMaxH: '250',
      list: [],
      listLoading: false,
      listQuery: {
        type: 1,
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      }
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    }
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/card/query_umcards', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};